import React from 'react';
import LoadingIndicator from '../../Search/SearchResultContainer/LoadingSearchIndicator';
function ProjectLoadingIndicator() {
  return /*#__PURE__*/React.createElement("div", {
    className: "project-loading-container vh-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row--always g-row--centered h-100"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, null)));
}
export default ProjectLoadingIndicator;